// parens: true → first group wrapped in (XX) like Brazil and North America
export const phoneFormatConfig = {
  // ── América Latina ──────────────────────────────────────────────────────────
  BR: {
    ddi: "55",
    parens: true,
    formats: [
      { localLength: 11, groups: [2, 5, 4], hyphenBetweenLast: true },
      { localLength: 10, groups: [2, 4, 4], hyphenBetweenLast: true },
    ],
  },
  AR: { ddi: "54",   formats: [{ localLength: 10, groups: [2, 4, 6] }] },
  CL: { ddi: "56",   formats: [{ localLength: 9,  groups: [1, 4, 4] }] },
  PE: { ddi: "51",   formats: [{ localLength: 9,  groups: [3, 3, 3] }] },
  CO: { ddi: "57",   formats: [{ localLength: 10, groups: [3, 3, 4] }] },
  MX: { ddi: "52",   formats: [{ localLength: 10, groups: [3, 3, 4] }] },
  UY: { ddi: "598",  formats: [{ localLength: 8,  groups: [4, 4] }] },
  PY: { ddi: "595",  formats: [{ localLength: 9,  groups: [3, 3, 3] }] },
  BO: { ddi: "591",  formats: [{ localLength: 8,  groups: [4, 4] }] },
  EC: { ddi: "593",  formats: [{ localLength: 9,  groups: [2, 3, 4] }] },
  GT: { ddi: "502",  formats: [{ localLength: 8,  groups: [4, 4] }] },
  HN: { ddi: "504",  formats: [{ localLength: 8,  groups: [4, 4] }] },
  PA: { ddi: "507",  formats: [{ localLength: 8,  groups: [4, 4] }] },
  CR: { ddi: "506",  formats: [{ localLength: 8,  groups: [4, 4] }] },
  DO: { ddi: "1809", formats: [{ localLength: 7,  groups: [3, 4] }] },
  SV: { ddi: "503",  formats: [{ localLength: 8,  groups: [4, 4] }] },
  NI: { ddi: "505",  formats: [{ localLength: 8,  groups: [4, 4] }] },
  VE: { ddi: "58",   formats: [{ localLength: 10, groups: [3, 3, 4] }] },
  HT: { ddi: "509",  formats: [{ localLength: 8,  groups: [4, 4] }] },
  CU: { ddi: "53",   formats: [{ localLength: 8,  groups: [4, 4] }] },

  // ── América do Norte ────────────────────────────────────────────────────────
  US: {
    ddi: "1",
    parens: true,
    formats: [{ localLength: 10, groups: [3, 3, 4], hyphenBetweenLast: true }],
  },
  CA: {
    ddi: "1",
    parens: true,
    formats: [{ localLength: 10, groups: [3, 3, 4], hyphenBetweenLast: true }],
  },

  // ── Europa ──────────────────────────────────────────────────────────────────
  // Reino Unido: 07XXX XXXXXX → sem prefixo 0 = 10 dígitos locais
  GB: { ddi: "44",  formats: [{ localLength: 10, groups: [4, 6] }] },
  // Alemanha: celular 15X/16X/17X XXXXXXXX → 10 dígitos locais (sem 0 inicial)
  DE: {
    ddi: "49",
    formats: [
      { localLength: 10, groups: [3, 3, 4] },
      { localLength: 9,  groups: [3, 3, 3] },
    ],
  },
  // França: 06/07 XX XX XX XX → 9 dígitos locais (sem 0 inicial)
  FR: { ddi: "33",  formats: [{ localLength: 9, groups: [1, 2, 2, 2, 2] }] },
  // Espanha: XXX XXX XXX → 9 dígitos
  ES: { ddi: "34",  formats: [{ localLength: 9, groups: [3, 3, 3] }] },
  // Itália: celular 3XX XXX XXXX → 10 dígitos; fixo 9 dígitos
  IT: {
    ddi: "39",
    formats: [
      { localLength: 10, groups: [3, 3, 4] },
      { localLength: 9,  groups: [3, 3, 3] },
    ],
  },
  // Portugal: 9XX XXX XXX → 9 dígitos
  PT: { ddi: "351", formats: [{ localLength: 9, groups: [3, 3, 3] }] },
  // Países Baixos: 06 XXXXXXXX → 9 dígitos (sem 0 inicial: XX XXX XXXX)
  NL: { ddi: "31",  formats: [{ localLength: 9, groups: [2, 3, 4] }] },
  // Polônia: XXX XXX XXX → 9 dígitos
  PL: { ddi: "48",  formats: [{ localLength: 9, groups: [3, 3, 3] }] },
  // Suécia: 7X XXX XXXX → 9 dígitos (sem 0 inicial: XX XXX XXXX)
  SE: { ddi: "46",  formats: [{ localLength: 9, groups: [2, 3, 4] }] },
  // Suíça: 7X XXX XX XX → 9 dígitos (sem 0 inicial)
  CH: { ddi: "41",  formats: [{ localLength: 9, groups: [2, 3, 2, 2] }] },
  // Bélgica: 4XX XX XX XX → 9 dígitos (sem 0 inicial)
  BE: { ddi: "32",  formats: [{ localLength: 9, groups: [3, 2, 2, 2] }] },
  // Áustria: celular 6XX XXXXXXX → 9-10 dígitos (sem 0 inicial)
  AT: {
    ddi: "43",
    formats: [
      { localLength: 10, groups: [3, 3, 4] },
      { localLength: 9,  groups: [3, 3, 3] },
    ],
  },
};

function selectFormat(countryCfg, localDigitsLength) {
  if (!countryCfg) return null;
  let match = countryCfg.formats.find(
    (f) => localDigitsLength <= f.localLength
  );
  if (!match) {
    match = countryCfg.formats[countryCfg.formats.length - 1];
  }
  return match;
}

function applyParensFormat(groups, fmt) {
  const [first, ...rest] = groups;
  if (rest.length === 0) return `(${first}`;
  if (fmt.hyphenBetweenLast && rest.length >= 2) {
    const restCopy = [...rest];
    const last = restCopy.pop();
    const beforeLast = restCopy.pop();
    const mid = restCopy.length ? restCopy.join(" ") + " " : "";
    return `(${first}) ${mid}${beforeLast}-${last}`;
  }
  return `(${first}) ${rest.join(" ")}`;
}

function applyPlainFormat(groups, fmt) {
  if (fmt.hyphenBetweenLast && groups.length >= 2) {
    const copy = [...groups];
    const last = copy.pop();
    const beforeLast = copy.pop();
    const prefix = copy.length ? copy.join(" ") + " " : "";
    return `${prefix}${beforeLast}-${last}`;
  }
  return groups.join(" ");
}

export function formatPhone(countryCode, digits = "") {
  const cfg = phoneFormatConfig[countryCode];
  const raw = String(digits).replace(/\D/g, "");
  if (!cfg) return raw;
  const { ddi } = cfg;

  if (!raw.startsWith(ddi)) return raw;

  const local = raw.slice(ddi.length);
  const fmt = selectFormat(cfg, local.length);
  if (!fmt) return `+${ddi}` + (local ? ` ${local}` : "");

  const groups = [];
  let cursor = 0;
  for (let i = 0; i < fmt.groups.length; i++) {
    const size = fmt.groups[i];
    const slice = local.slice(cursor, cursor + size);
    if (!slice) break;
    groups.push(slice);
    cursor += size;
  }

  let visual = `+${ddi}`;
  if (groups.length > 0) {
    if (fmt.hyphenBetweenLast && groups.length >= 2) {
      const last = groups.pop();
      const beforeLast = groups.pop();
      visual += ` ${groups.join(" ")}${
        groups.length ? " " : ""
      }${beforeLast}-${last}`;
    } else {
      visual += ` ${groups.join(" ")}`;
    }
  }

  return visual;
}

export const getPhoneFormatter = (countryCode) => (digits) =>
  formatPhone(countryCode, digits);

export function formatLocalPhone(countryCode, localDigits = "") {
  const cfg = phoneFormatConfig[countryCode];
  const local = String(localDigits).replace(/\D/g, "");
  if (!cfg || !local) return local;

  const fmt = selectFormat(cfg, local.length);
  if (!fmt) return local;

  const groups = [];
  let cursor = 0;
  for (let i = 0; i < fmt.groups.length; i++) {
    const size = fmt.groups[i];
    const slice = local.slice(cursor, cursor + size);
    if (!slice) break;
    groups.push(slice);
    cursor += size;
  }

  if (groups.length === 0) return local;

  return cfg.parens
    ? applyParensFormat(groups, fmt)
    : applyPlainFormat(groups, fmt);
}

export function getLocalPlaceholder(countryCode) {
  const cfg = phoneFormatConfig[countryCode];
  if (!cfg) return "000000000";
  const maxLength = Math.max(...cfg.formats.map((f) => f.localLength));
  return formatLocalPhone(countryCode, "0".repeat(maxLength)) || "000000000";
}

export function getLocalMaxLength(countryCode) {
  const cfg = phoneFormatConfig[countryCode];
  if (!cfg) return 15;
  return Math.max(...cfg.formats.map((f) => f.localLength));
}

export const getPhonePlaceholder = (countryCode) => {
  const cfg = phoneFormatConfig[countryCode];
  if (!cfg) return "+00";
  const longest = cfg.formats.reduce(
    (a, b) => (b.localLength > a.localLength ? b : a),
    cfg.formats[0]
  );
  const fakeLocal = longest.groups.map((g) => "0".repeat(g));
  let visual = `+${cfg.ddi}`;
  if (fakeLocal.length) {
    if (longest.hyphenBetweenLast && fakeLocal.length >= 2) {
      const last = fakeLocal.pop();
      const beforeLast = fakeLocal.pop();
      visual += ` ${fakeLocal.join(" ")}${
        fakeLocal.length ? " " : ""
      }${beforeLast}-${last}`;
    } else {
      visual += ` ${fakeLocal.join(" ")}`;
    }
  }
  return visual;
};
